// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1q9sJ","col":"styles_col__VCwzZ"};